import i18n from './i18n';

export const TEXT = {
    get pleaseProceedText() {
        return i18n('confirm_please-proceed');
    },
};
